import React from 'react';
import Icon from '../../../components/AppIcon';
import { getTopForms } from '../../../services/eventAnalyticsService';

const TopFormsTable = () => {
  const forms = getTopForms();

  return (
    <div className="bg-card border border-border rounded-xl p-6">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h3 className="text-base font-semibold text-foreground">Top Performing Forms</h3>
          <p className="text-xs text-muted-foreground mt-0.5">Ranked by submission volume</p>
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left text-xs text-muted-foreground font-medium pb-3 pr-4">#</th>
              <th className="text-left text-xs text-muted-foreground font-medium pb-3 pr-4">Form Name</th>
              <th className="text-right text-xs text-muted-foreground font-medium pb-3 pr-4">Views</th>
              <th className="text-right text-xs text-muted-foreground font-medium pb-3 pr-4">Submissions</th>
              <th className="text-right text-xs text-muted-foreground font-medium pb-3 pr-4">Conv. Rate</th>
              <th className="text-right text-xs text-muted-foreground font-medium pb-3">Trend</th>
            </tr>
          </thead>
          <tbody>
            {forms?.map((form, idx) => {
              const trendPositive = form?.trend?.startsWith('+');
              return (
                <tr key={form?.id} className="border-b border-border/50 hover:bg-muted/30 transition-colors">
                  <td className="py-3 pr-4 text-muted-foreground text-xs">{idx + 1}</td>
                  <td className="py-3 pr-4">
                    <div className="flex items-center gap-2">
                      <div className="w-6 h-6 rounded-md bg-primary/10 flex items-center justify-center flex-shrink-0">
                        <Icon name="FileText" size={12} color="var(--color-primary)" />
                      </div>
                      <span className="text-foreground font-medium text-xs">{form?.name}</span>
                    </div>
                  </td>
                  <td className="py-3 pr-4 text-right text-xs text-muted-foreground">{form?.views?.toLocaleString()}</td>
                  <td className="py-3 pr-4 text-right text-xs text-foreground font-medium">{form?.submissions?.toLocaleString()}</td>
                  <td className="py-3 pr-4 text-right">
                    <span className="text-xs font-semibold text-primary">{form?.rate}</span>
                  </td>
                  <td className="py-3 text-right">
                    <span className={`text-xs font-medium ${trendPositive ? 'text-success' : 'text-error'}`}>
                      {form?.trend}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TopFormsTable;
